<template>
  <Modal
    @closeModal="closeModal"
    v-show="showModal"
    class="modal"
    id="content-options-modal"
    title="Add content to area"
  >
    <template v-slot:body>
      <div class="content-title">Media</div>
      <div class="content-options-container">
        <div class="content-option upload" @click="openUploadModal">
          <div class="logo">
            <i class="material-icons-outlined align-middle">upload</i>
          </div>
          <div class="option-body">
            <div class="option-title">Upload new media</div>
            <div class="option-description">Images, Videos, PDF</div>
          </div>
        </div>
        <div class="content-option browse" @click="openBrowserContentModal">
          <div class="logo">
            <i class="material-icons-outlined align-middle">folder_open</i>
          </div>
          <div class="option-body">
            <div class="option-title">Browse media library</div>
            <div class="option-description">Add media from your library</div>
          </div>
        </div>
      </div>

      <div class="content-title">Templates</div>

      <div class="content-options-container">
        <div class="content-option" @click="createNewTemplate">
          <div class="logo">
            <i class="material-icons-outlined align-middle">add_photo_alternate</i>
          </div>
          <div class="option-body">
            <div class="option-title">Create new template</div>
            <div class="option-description">Create a template that fits the area</div>
          </div>
        </div>
        <div class="content-option" @click="openTemplateModal">
          <div class="logo">
            <i class="material-icons-outlined align-middle">photo_size_select_large</i>
          </div>
          <div class="option-body">
            <div class="option-title">Browse Template Library</div>
            <div class="option-description">Add template from your library</div>
          </div>
        </div>
      </div>
    </template>

    <template v-slot:footer><div></div> </template>
  </Modal>
</template>

<script>
  import Modal from '@/components/common/Modal.vue';
  import EventBus from '@/models/EventBus';

  export default {
    name: 'PlaylistContentModal',

    components: { Modal },

    data() {
      return { showModal: false };
    },

    mounted() {
      this.showModal = true;
    },

    methods: {
      closeModal() {
        this.showModal = false;
        this.$emit('closeModal');
      },

      openBrowserContentModal() {
        this.closeModal();
        EventBus.$emit('OPEN_CONTENT_BROWSER');
        this.$emit('openContentBrowser');
      },

      openTemplateModal() {
        this.closeModal();
        this.$emit('openTemplateModal');
      },

      createNewTemplate() {
        this.closeModal();
        this.$emit('createNewTemplate');
      },

      openUploadModal() {
        this.closeModal();
        this.$emit('openUploadModal');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .modal {
    .modal-container {
      width: min(732px, 90vw);
    }
  }

  .content-options-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;
    margin-bottom: 24px;

    .content-option {
      display: grid;
      background-color: $backgroundGrey2;
      grid-template-columns: 48px auto;
      padding: 24px;
      text-align: left;
      cursor: pointer;
      transition: background 0.25s ease-in;

      &:hover {
        background-color: $backgroundGrey;
      }

      .logo {
        display: flex;
        justify-content: center;
        align-items: center;
        padding-right: 4px;
        color: $primaryRed;

        i {
          font-size: 50px;
        }
      }

      .option-body {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-left: 10px;

        .option-description {
          font-size: 14px;
          line-height: 18px;
        }
      }

      .option-title {
        font-size: 16px;
        font-weight: bold;
        line-height: 24px;
        margin-bottom: 4px;
      }
    }

    @media screen and (max-width: 480px) {
      display: flex;
      flex-direction: column;
    }
  }

  .content-title {
    display: flex;
    justify-content: left;
    width: 100%;
    font-size: 16px;
    font-weight: bold;
    line-height: 24px;
    margin-bottom: 20px;
  }

  .modal {
    .modal-header {
      font-size: 20px;
      line-height: 32px;
      background: none !important;
      border: none !important;

      position: relative;
      padding: 27px 0 19px;
      margin: 0 32px;
      color: $primaryText;

      @media screen and (max-width: 480px) {
        display: flex;
        justify-content: center;
      }
    }
  }
</style>
